import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({ title, desc, meta }) => {
    return <Helmet
        htmlAttributes={{
            lang: "en",
        }}
        title={ title }
        meta={[
            {
                name: `description`,
                content: desc,
            },
            {
                property: `og:image`,
                content: `https://repogit.netlify.com${ require(`../images/preview.png`) }`
            },
            {
                property: `og:title`,
                content: title,
            },
            {
                property: `og:description`,
                content: desc,
            },
            {
                property: `og:type`,
                content: `website`,
            },
            {
                name: `twitter:card`,
                content: `summary_large_image`,
            },
            {
                name: `twitter:image`,
                content: `https://repogit.netlify.com${ require(`../images/preview.png`) }`
            },
            {
                name: `twitter:creator`,
                content: "Vetted",
            },
            {
            name: `twitter:title`,
                content: title,
            },
            {
            name: `twitter:description`,
                content: desc,
            },
        ].concat(meta)}
    />
}

SEO.defaultProps = {
    meta: []
}

export default SEO;